export default {
  common: {
    viewAll: 'View all',
  },
  featured: {
    title: 'Featured Contests',
  },
  myEntriesNew: {
    title__hasPlural: {
      one: 'Missing picks for 1 contest',
      other: 'Missing picks for {{count}} contests',
    },
  },
  myEntries: {
    title: 'My Entries',
    entryFee: 'Entry',
    progress: '{{totalSpots}} of {{maxEntries}}',
    prizes: 'Prizes',
    threedot: {
      withdraw: 'Withdraw entry',
    },
    actions: {
      edit: 'Edit',
      view: 'View',
    },
  },
  myEntriesLinks: {
    title: 'My Contests',
    entriesCount__hasPlural: {
      one: '{{count}} Entry',
      other: '{{count}} Entries',
    },
    live: 'Live',
    finalized: 'Settled',
    upcoming: 'Upcoming',
  },
  playWithPeopleYouFollow: {
    title: 'Play with People you follow',
    text: {
      followersEntered__hasPlural: {
        one: '{{count}} follower entered',
        other: '{{count}} followers entered',
      },
      followeesEntered__hasPlural: {
        one: '{{count}} person you follow entered',
        other: '{{count}} people you follow entered',
      },
    },
    cta__hasPlural: {
      zero: 'Max entered',
      one: 'Add entry',
      other: 'Add entries',
    },
  },
};
